import React, { Component } from 'react';
import './Skew.css';

export default class Element extends Component {

    constructor(props) {
        super(props);
        this.state = {
            position: 'right'
        };
    }

    componentDidMount() {
        if (this.props.position) {
            this.setState({position: this.props.position});
        }
    }

    render() {
        return (
            <div className={"Skew Skew--" + this.state.position} style={{backgroundImage:`linear-gradient(#${this.props.top}, #${this.props.bottom})`, transform: 'skew(-20deg)'}}>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Skew/Skew.js